import {BaseAddressUnDeletable} from '../../../common/entities';

export class OfficeLocation extends BaseAddressUnDeletable {
    name: string;
}
